import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { FaRegClock } from 'react-icons/fa'
import { IoMdArrowRoundForward } from 'react-icons/io'
import { Link } from 'gatsby'
import styled from 'styled-components'

const Post = ({ excerpt, frontmatter }) => {
  const { title, image, slug, date, category, readTime } = frontmatter
  return (
    <Wrapper>
      <Link to={`/posts/${slug}`} className="info">
        <h1>{title}</h1>
        <footer>
          <span className="date">
            <FaRegClock className="icon" />
            {date}
          </span>
          <span>{readTime} min read</span>
        </footer>
      </Link>
    </Wrapper>
  )
}

const Wrapper = styled.article`
  margin-bottom: 0px;
  .info {
    text-align: left;
    padding: 10px;
  }
  .info:hover {
    border-radius: 10px;
    background: aliceblue;
  }

  h1 {
    font-weight: 700;
    margin-bottom: 10px;
    text-transform: initial;
    font-size: 20px;
  }

  p {
    color: var(--clr-grey-5);
    line-height: 1.8;
  }
  footer {
    padding-top: 1px;
    border-top: 1px solid var(--clr-grey-9);
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--clr-grey-5);
    margin-bottom: 10px;

    & .date {
      display: flex;
      align-items: center;
      font-size: 12px;
      & .icon {
        color: var(--clr-primary-5);
        margin-right: 0.5rem;
      }
    }
    span {
      font-size: 12px;
    }
  }
  @media (max-width: 600px) {
    .img {
      height: 20rem;
    }
  }
  @media (min-width: 800px) {
    .img {
      height: 25rem;
    }
  }
  @media (min-width: 992px) {
  }

  @media (min-width: 576px) {
    & {
      display: grid;
      grid-template-columns: 45rem 1fr;
      column-gap: 1.5rem;
      .info {
        text-align: left;
      }
      .img {
        height: 100%;
        max-height: 20rem;
      }
      .underline {
        margin-left: 0;
        margin-right: 0;
      }
    }
  }

  // Medium devices (tablets, 768px and up)
  @media (min-width: 768px) {
  }

  // Large devices (desktops, 992px and up)
  @media (min-width: 992px) {
  }

  // X-Large devices (large desktops, 1200px and up)
  @media (min-width: 1200px) {
  }

  // XX-Large devices (larger desktops, 1400px and up)
  @media (min-width: 1400px) {
  }
`

export default Post
